export const api = {
  queryAppointApprovalList: "/bms/vehicle/appointment/page.json", // 查询预约审批列表
  fallbackVehicleAppointment:
    "/bms/coldstorage/dispatchVehicleAppointment/fallbackVehicleAppointment.json", // 流程回退
  terminationVehicleAppointment:
    "/bms/coldstorage/dispatchVehicleAppointment/terminationVehicleAppointment.json", // 流程终止
};
